import { supabase } from "../../Services/supabaseClient";

/**
 * Returns bank accounts from chart_of_accounts for a company.
 * Bank accounts are: type = 'Asset' AND category contains 'bank' (case-insensitive)
 * IMPORTANT: chart_of_accounts uses `account_number` (not `code`)
 */
export async function fetchCompanyBankAccounts(companyId) {
  if (!companyId) return [];

  const { data, error } = await supabase
    .from("chart_of_accounts")
    .select("id, account_number, name, type, category")
    .eq("company_id", companyId)
    .eq("type", "Asset")
    .ilike("category", "%bank%")
    .order("name", { ascending: true });

  if (error) {
    console.error("fetchCompanyBankAccounts error:", error);
    return [];
  }

  return data || [];
}
